import type { FieldName } from './FieldName'

/** Locale label key for every wire field token the API names in `other_field`. */
export const fieldNameKey = Object.freeze({
  endDate: 'presentation.errors.fieldName.endDate',
  startDate: 'presentation.errors.fieldName.startDate'
} satisfies Record<FieldName, `presentation.errors.fieldName.${string}`>)
